import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { actualizarKilometraje, getUnidadesKilometraje } from "./integracion";
import InputText from "../../../components/atoms/InputText/InputText";
import './KilometrajePorUnidad.scss'
import { convertirFormatoFecha, extraerHora, formatearFecha, formatearTiempo, formateoDateATiempo } from "../../../utilidades/formateos";
import { desEncriptar } from "../../../utilidades/encriptacion";
import Boton from "../../../components/atoms/Boton/Boton";
import { Tooltip } from "@mui/material";

const KilometrajePorUnidad = () => {
    const [data, setData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");
    const [objetoActualizado, setObjetoActualizado] = useState(null)


    useEffect(() => {
        getUnidadesKilometraje(setData);
    }, []);


    const onGlobalFilterChange = (e) => {
        setGlobalFilter(e.target.value);
    };

    // Función para actualizar el kilometraje
    const onKilometrajeChange = (e, rowIndex) => {
        const newData = [...data];  // Copiar los datos actuales
        newData[rowIndex].KILOMETRAJE = e.target.value; // Actualizar el kilometraje de la fila
        setData(newData); // Establecer los nuevos datos en el estado


    };
    const onKilometrajeBlur = (e, id) => {
        const newData = data.map((item) => item.ID === id ? { ...item, KM_INICIAL: e.target.value } : item); setData(newData);
        const updatedItem = newData.find(item => item.ID === id);
        setData(newData); // Establecer los nuevos datos en el estado
        console.log("onKilometrajeBlur", updatedItem);
        if (updatedItem) {

            // actualizarKilometraje({ ID: updatedItem.ID, KM_INICIAL: updatedItem.KM_INICIAL, KILOMETRAJE: updatedItem.KILOMETRAJE, KM_WIALON: updatedItem.KM_WIALON });
        }
    }
    const onKilometrajeInicialChange = (e, id) => {
        const newData = data.map((item) => item.ID === id ? { ...item, KM_REFERENCIA: e.target.value } : item); setData(newData);
        const updatedItem = newData.find(item => item.ID === id);
        setData(newData); // Establecer los nuevos datos en el estado
        if (updatedItem) {


            // actualizarKilometraje({ ID: updatedItem.ID, KM_INICIAL: updatedItem.KM_INICIAL, KILOMETRAJE: updatedItem.KILOMETRAJE, KM_WIALON: updatedItem.KM_WIALON });
        }

    };
    const onKilometrajeWialonChange = (id) => {
        const dataClient = desEncriptar(sessionStorage.getItem('dataClient'), process.env.REACT_APP_CLAVE_INCRIPTACION)
        const userInfo = JSON.parse(dataClient)
        const newData = data.map((item) => item.ID === id ? { ...item, KM_WIALON: !item.KM_WIALON } : item); setData(newData);
        // Actualizar el estado con los nuevos datos
        const updatedItem = newData.find(item => item.ID === id);
        if (updatedItem) {
            actualizarKilometraje({ ID: updatedItem.ID, USER: userInfo.user.ID, KM_REFERENCIA: updatedItem.KM_REFERENCIA, KM_INICIAL: updatedItem.KM_INICIAL, KILOMETRAJE: updatedItem.KILOMETRAJE, KM_WIALON: updatedItem.KM_WIALON });
        }
    };
    const onKilometrajeInicialBlur = (e, id) => {
        const dataClient = desEncriptar(sessionStorage.getItem('dataClient'), process.env.REACT_APP_CLAVE_INCRIPTACION)
        const userInfo = JSON.parse(dataClient)
        const newData = data.map((item) => item.ID === id ? { ...item, KM_INICIAL: e.target.value, KILOMETRAJE: e.target.value } : item); setData(newData);
        const updatedItem = newData.find(item => item.ID === id);
        setData(newData); // Establecer los nuevos datos en el estado
        if (updatedItem) {

            actualizarKilometraje({ ID: updatedItem.ID, USER: userInfo.user.ID, KM_REFERENCIA: updatedItem.KM_REFERENCIA, KM_INICIAL: updatedItem.KM_INICIAL, KILOMETRAJE: updatedItem.KILOMETRAJE, KM_WIALON: updatedItem.KM_WIALON });
        }
    }

    // Función de la plantilla de kilometraje
    const kilometrajeTemplate = (rowData, { rowIndex }) => {
        return (
            <InputText
                title=""
                value={rowData.KILOMETRAJE}
                onBlur={(e) => onKilometrajeBlur(e, rowIndex)} // Guardar el valor cuando se pierde el foco
                onChange={(e) => onKilometrajeChange(e, rowIndex)} // Cambiar el valor cuando se escribe
            // autoFocus
            />
        );
    };
    const kilometraje_inicial_Template = (rowData, { rowIndex }) => {
        return (
            <InputText
                title=""
                value={rowData.KM_REFERENCIA}
                // onBlur={(e) => } // Guardar el valor cuando se pierde el foco
                onChange={(e) => onKilometrajeInicialChange(e, rowData.ID)} // Cambiar el valor cuando se escribe
            // autoFocus
            />
        );
    };

    const kilometraje_wialon_template = (rowData) => {
        return (
            <div style={{ cursor: 'pointer' }} onClick={() => onKilometrajeWialonChange(rowData.ID)}>
                {rowData.KM_WIALON === true ? '✅' : '❌'}
            </div>
        );
    };

    const fecha_km_template = (rowData) => {
        return (
            <>
                {rowData.KM_REFERENCIA_FECHA == null ? 'sin validar' : convertirFormatoFecha(formatearFecha(rowData.KM_REFERENCIA_FECHA)) + ' : ' + extraerHora(rowData.KM_REFERENCIA_FECHA)}
            </>
        );
    };
    const actualizar = (rowData) => {
        return (
            <>
                <Tooltip title='Preciona este boton para guardar cambios'>
                    <div>
                        <Boton onClick={(e) => { onKilometrajeInicialBlur(e, rowData.ID) }}>Actualizar</Boton>
                    </div>
                </Tooltip>
            </>
        );
    };

    return (
        <div className="KilometrajePorUnidad">
            <InputText
                title="Buqueda"
                value={globalFilter}
                onChange={onGlobalFilterChange}
                placeholder="Buscar en toda la tabla"
                style={{ marginBottom: '20px', width: '300px' }}
            />
            <DataTable
                value={data}
                scrollable
                scrollHeight="calc(100vh - 180px)"
                globalFilter={globalFilter}
                responsiveLayout="scroll"
                virtualScrollerOptions={{ itemSize: 40 }}
            >
                <Column field="ID" header="ID" sortable />
                <Column field="DESCRIPCION" header="DESCRIPCION" sortable />
                <Column field="TIPO" header="TIPO" sortable />
                <Column
                    field="KILOMETRAJE"
                    header="KILOMETRAJE"
                    sortable
                // body={kilometrajeTemplate} // Usar el template para que sea editable
                />
                <Column field="KM_WIALON" header="KM_WIALON" body={kilometraje_wialon_template} sortable />
                <Column
                    field="KM_INICIAL"
                    header="KM_INICIAL"
                    // body={kilometraje_inicial_Template}
                    sortable
                />
                <Column
                    field="KM_REFERENCIA"
                    header="KM_REFERENCIA"
                    body={kilometraje_inicial_Template}
                    sortable
                />
                <Column field="KM_REFERENCIA_FECHA" header="KM_REFERENCIA_FECHA" body={fecha_km_template} sortable />
                <Column
                    header="Actualizar"
                    body={actualizar}
                    sortable
                />
            </DataTable>
        </div>
    );
};

export default KilometrajePorUnidad;
